<template>
    <div>
        <div id="threePipeline" :style="divStyle" class="scrollbar">
            <Drawer title="Basic Drawer" :closable="false" v-model="showDraw" :mask="false" transfer>
                {{message}}
            </Drawer>
        </div>
    </div>
</template>

<script>
    import * as THREE from 'three'
    import TrackballControls from 'three-trackballcontrols'
    import particleFire from 'three-particle-fire';
    import Stats from 'stats-js'
    particleFire.install({
        THREE: THREE
    });
    export default {
        computed: {
            divStyle() {
                var style = {};
                style.width = this.width + 'px';
                style.height = this.height + 'px';
                //style.backgroundImage = 'url('+ require('./waveBg.png') + ')';
                //style.backgroundSize = '100% 99.9%';
                return style;
            }
        },
        mounted() {
            if(this.$parent.$refs.mainContent){
                style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
            }else{
                style.width = window.innerWidth - 279 + "px";
            }
            this.height = this.$parent.$refs.mainContent.clientHeight - 52;
            this.init();
            this.animate();
        },
        data() {
            return {
                showDraw: false,
                showDrawList: [],
                camera: null,
                scene: null,
                renderer: null,
                controls: null,
                container: null,
                width: null,
                height: null,
                INTERSECTED: null,
                line: [
                    new THREE.Vector3(-100, 0, 0),
                    new THREE.Vector3(0, 0, 0),
                    new THREE.Vector3(0, 0, -100)
                ],
                cone: [],
                raycaster: null,
                stats: null,
                mouse: new THREE.Vector2(),
                message: null
            }
        },
        methods: {
            init() {
                this.container = document.getElementById('threePipeline');
                this.renderer = new THREE.WebGLRenderer();
                //设置当前显示设备的物理像素分辨率与 CSS 像素分辨率的比率
                this.renderer.setPixelRatio(window.devicePixelRatio);
                this.renderer.setSize(this.width, this.height);
                this.container.appendChild(this.renderer.domElement);

                this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, 1, 1000);
                this.camera.position.set(0, 300, 300);
                this.camera.lookAt(0, 0, 0);

                this.controls = new TrackballControls(this.camera, this.renderer.domElement);
                this.controls.minDistance = 50;
                this.controls.maxDistance = 500;

                this.scene = new THREE.Scene();
                this.scene.background = new THREE.Color(0x444444);
                this.scene.add(new THREE.AmbientLight(0x444444));
                let light = new THREE.PointLight(0xffffff);
                light.position.copy(this.camera.position);
                this.scene.add(light);

                let curveline = new THREE.CatmullRomCurve3(this.line);
                curveline.curveType = 'catmullrom';
                curveline.tension = 0;
                curveline.closed = false;
                let extrudeSettings = {
                    steps: 100,
                    bevelEnabled: false,
                    extrudePath: curveline
                };
                let points = [],
                    holes = [],
                    length = 100,
                    circle = 10;
                for (let i = 0; i <= length; i++) {
                    points.push(new THREE.Vector2(circle * Math.cos(Math.PI * 2 * i / length), circle * Math.sin(Math.PI *
                        2 * i / length)));
                    holes.push(new THREE.Vector2((circle - 1) * Math.cos(Math.PI * 2 * i / length), (circle - 1) * Math
                        .sin(Math.PI * 2 * i / length)))
                }
                let shape = new THREE.Shape(points);
                //shape.absarc(0, 0, 10, 0, 2 * Math.PI, false);
                let hole = new THREE.Path(holes);
                //hole.absarc(0, 0, 9, 0, 2 * Math.PI, true);
                shape.holes.push(hole);
                let geometry = new THREE.ExtrudeBufferGeometry(shape, extrudeSettings);
                let material = new THREE.MeshLambertMaterial({
                    //color: 0x1E90FF,
                    color: 0xE1A559,
                    wireframe: false
                });
                let mesh = new THREE.Mesh(geometry, material);
                this.scene.add(mesh);

                let geometry0 = new THREE.ConeBufferGeometry(5, 20, 4);
                let material0 = new THREE.MeshLambertMaterial({
                    color: 0xffff00
                });
                this.cone[0] = new THREE.Mesh(geometry0, material0);
                this.cone[0].position.set(-50, 20, 0);
                this.cone[0].rotation.x = Math.PI;
                this.scene.add(this.cone[0]);
                this.showDrawList.push(this.cone[0].uuid);
                
                let material1 = new THREE.MeshLambertMaterial({
                    color: 0xffff00
                });
                this.cone[1] = new THREE.Mesh(geometry0, material1);
                this.cone[1].position.set(0, 20, -50);
                this.cone[1].rotation.x = Math.PI;
                this.scene.add(this.cone[1]);
                this.showDrawList.push(this.cone[1].uuid);

                this.raycaster = new THREE.Raycaster();
                this.container.addEventListener('mousemove', this.onDocumentMouseMove, false);
                
                let helper = new THREE.GridHelper( 300, 20 ,0x888888 ,0x888888);
				//helper.rotation.x = Math.PI / 2;
				this.scene.add( helper );
                
                this.stats = new Stats();
				this.container.appendChild( this.stats.dom );
            },
            onDocumentMouseMove(event) {
                event.preventDefault();
                this.mouse.x = (event.layerX / this.width) * 2 - 1;
                this.mouse.y = -(event.layerY / this.height) * 2 + 1;
                //console.log(this.mouse.x + " " + this.mouse.y);
            },
            animate() {
                requestAnimationFrame(this.animate);
                this.render();
                this.controls.update();
                this.stats.update();
            },
            render() {
                this.cone[0].rotation.y += 0.1;
                this.cone[1].rotation.y += 0.1;
                this.raycaster.setFromCamera(this.mouse, this.camera);
                let intersects = this.raycaster.intersectObjects(this.scene.children);
                //console.log(this.scene.children);
                if (intersects.length > 0) {
                    //let targetDistance = intersects[ 0 ].distance;
                    if (this.INTERSECTED != intersects[0].object) {
                        if (this.INTERSECTED  && this.showDrawList.indexOf(this.INTERSECTED.uuid) != -1) {
                            this.INTERSECTED.material.color = this.INTERSECTED.currentHex;
                        }
                        this.INTERSECTED = intersects[0].object;
                        if (this.showDrawList.indexOf(this.INTERSECTED.uuid) != -1) {
                            this.showDraw = true;
                            this.message = this.INTERSECTED.uuid;
                            this.INTERSECTED.currentHex = new THREE.Color(
                                this.INTERSECTED.material.color.r,
                                this.INTERSECTED.material.color.g,
                                this.INTERSECTED.material.color.b
                            );
                            this.INTERSECTED.material.color.set(0xff0000);
                        }
                    }
                } else {
                    if (this.INTERSECTED && this.showDrawList.indexOf(this.INTERSECTED.uuid) != -1) {
                        this.INTERSECTED.material.color = this.INTERSECTED.currentHex;
                    } else if (this.INTERSECTED && this.showDrawList.indexOf(this.INTERSECTED.uuid) == -1) {
                        this.showDraw = false;
                    }
                    this.INTERSECTED = null;
                }

                this.renderer.render(this.scene, this.camera);
            }
        }
    }
</script>

<style scoped>
    /*自定义滚动条*/
    .scrollbar {
        overflow-x: auto;
        overflow-y: auto;
    }

    .scrollbar::-webkit-scrollbar {
        width: 0px;
    }
</style>
